import { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Solutions.css';

gsap.registerPlugin(ScrollTrigger);

const faqs = [
  {
    question: 'Comment démarre un projet sur-mesure ?',
    answer: 'Une visite, une écoute, un plan 3D. Du premier croquis à la pose finale, chaque étape est pensée pour transformer votre vision en réalité.',
  },
  {
    question: 'Quel budget prévoir pour mon aménagement ?',
    answer: 'Des devis transparents, adaptés à chaque ambition. Nous concevons des solutions durables qui valorisent votre investissement — sans mauvaise surprise.',
  },
  {
    question: 'Quelles essences de bois utilisez-vous ?',
    answer: 'Chêne, noyer, cèdre, hêtre… Nos experts sélectionnent les matières premières les plus nobles pour garantir robustesse et élégance absolue.',
  },
  {
    question: 'Peut-on marier tradition et modernité ?',
    answer: 'C\'est notre signature. Nos artisans revisitent le salon marocain avec des lignes épurées, mariant parfaitement authenticité et design contemporain.',
  },
  {
    question: 'Qui assure le suivi de mon chantier ?',
    answer: 'Un interlocuteur dédié vous accompagne de A à Z. Prise de cotes, fabrication, livraison, installation — on gère tout, vous profitez.',
  },
  {
    question: 'Pourquoi choisir Luxury Wood Concept ?',
    answer: 'La précision de nos machines, le doigté de nos artisans, et 15 ans d\'expertise au Maroc. Un rendu haut de gamme, sans compromis.',
  },
];

export default function Solutions() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const imageRef = useRef(null);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  useEffect(() => {
    // Section entrance
    gsap.fromTo(sectionRef.current,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
        },
      }
    );

    // Parallax on the side image
    if (imageRef.current) {
      gsap.to(imageRef.current, {
        y: -60,
        ease: 'none',
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
        },
      });
    }
  }, []);

  return (
    <section className="faq-section" id="solutions" ref={sectionRef}>
      <div className="faq-container">
        
        {/* Left: Accordion */}
        <div className="faq-left">
          <span className="faq-label">Questions Fréquentes</span>
          <h2 className="faq-title">
            ON VOUS<br />
            <em>RÉPOND.</em>
          </h2>

          <div className="faq-accordion">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className={`faq-item ${activeIndex === i ? 'faq-item--active' : ''}`}
                onClick={() => toggle(i)}
              >
                <div className="faq-item__header">
                  <span className="faq-item__number">0{i + 1}</span>
                  <h3 className="faq-item__question">{faq.question}</h3>
                  <span className="faq-item__icon">
                    {activeIndex === i ? '−' : '+'}
                  </span>
                </div>
                <div className={`faq-item__body ${activeIndex === i ? 'faq-item__body--open' : ''}`}>
                  <p className="faq-item__answer">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Atmospheric Image */}
        <div className="faq-right">
          <div className="faq-image-wrap">
            <img
              ref={imageRef}
              src="/images/faq-atelier.webp"
              alt="Artisan travaillant le bois"
              className="faq-image"
              loading="lazy"
            />
            <div className="faq-image-overlay" />
            {/* Floating quote */}
            <div className="faq-image-quote">
              <span>"Le détail<br/>qui signe<br/>l'œuvre."</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
